import { ArrowUpRight } from 'lucide-react'
import DirectionDimension from '@/frontend/features/Fde/investigations/DirectionDimension'
import { investigationLabel } from '@/frontend/features/Fde/investigations/format'
import type { InvestigationLabels, ResearchDirection } from '@/frontend/features/Fde/investigations/types'

interface Props { direction: ResearchDirection; copy: InvestigationLabels; onOpen: () => void; onFinding: (id: string) => void }

export default function DirectionRow({ direction, copy, onOpen, onFinding }: Props) {
  const resultId = direction.finding_ids?.[0]
  return <tr className="hover:bg-muted/15">
    <td className="min-w-56 max-w-2xl px-4 py-4">
      <button type="button" onClick={onOpen} className="flex w-full items-start gap-3 text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring">
        <span className="grid gap-1.5">
          <span className="line-clamp-2 font-medium leading-snug">{direction.brief?.title || direction.title}</span>
          <span className="line-clamp-2 text-xs leading-relaxed text-muted-foreground">{direction.brief?.upside || copy.direction_brief_missing_short}</span>
        </span>
        <ArrowUpRight className="mt-0.5 size-3.5 shrink-0 text-muted-foreground" aria-hidden />
      </button>
    </td>
    <td className="min-w-36 max-w-56 px-4 py-4"><DirectionDimension brief={direction.brief} copy={copy} /></td>
    <td className="px-4 py-4 text-xs text-muted-foreground">
      <div className="grid gap-2">
        <span>{investigationLabel(copy, 'direction_status', direction.status)}</span>
        {resultId && <button type="button" onClick={() => onFinding(resultId)} className="w-fit text-xs font-medium text-foreground hover:underline focus-visible:ring-2 focus-visible:ring-ring">{copy.direction_view_result}</button>}
      </div>
    </td>
  </tr>
}
